<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="menuData != '' && user_role == 1">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">{{menuData.menu_title}}</div>
                    </div>
                    <!--Forms-->
                    <form>
                        <div class="forms-container">
                            <div class="row no-margin">

                                <div class="col-12 forms-block">

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Title :</div>
                                        </div>

                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <input type="text" maxlength="190" v-validate="'required'" class="form-control" v-model="attachTitle" id="attachTitle" placeholder="Enter Title" name="title">
                                            <!-- <i v-show="errors.has('title')" class="fa fa-warning"></i> -->
                                            <span v-show="errors.has('title')" class="help is-danger">{{ errors.first('title') }}</span>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    <template v-if="menuData.allow_in_attachment == 3">
                                        <div class="common-form-field">
                                            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                                <div class="form-label">Document / Link:</div>
                                            </div>
                                            <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                                <v-select v-model="documentOrLink" name="documentOrLink" placeholder="Select Document or Link."
                                                          label="text"
                                                          :options="documentOrLinkArr" :clearable=false>
                                                </v-select>
                                                <!-- <i v-show="errors.has('documentOrLink')" class="fa fa-warning"></i> -->
                                                <span v-show="errors.has('documentOrLink')" class="help is-danger">{{ errors.first('documentOrLink') }}</span>
                                                <!-- <div class="requiredstar">*</div> -->
                                            </div>
                                        </div>

                                        <div class="common-form-field">
                                            <template v-if="flag">
                                                <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                                    <div class="form-label">Upload Document :</div>
                                                </div>
                                                <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                                    <vue-dropzone
                                                        ref="dropzone" 
                                                        id="dropzone" 
                                                        :options="dropzoneOptions"
                                                        @vdropzone-success = "uploadAttachment"
                                                        @vdropzone-removed-file="removedSelectedFile"
                                                        :useCustomSlot=true
                                                        >
                                                        <div class="dropzone-custom-content">
                                                            <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                                            <div class="subtitle">(Select files from your computer.)</div>
                                                        </div>
                                                    </vue-dropzone>
                                                    <!-- <div class="requiredstar">*</div> -->
                                                </div>
                                            </template>

                                            <template v-else>
                                                <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                                    <div class="form-label">Link :</div>
                                                </div>
                                                <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                                    <input v-validate="{url: {require_protocol: true }}" type="text" class="form-control" v-model="attachURL" id="attachURL" placeholder="Enter Link" name="abc">
                                                    <span v-show="errors.has('attachURL')" class="help is-danger">{{ "The Link field is not a valid URL." }}</span>
                                                    <!-- <div class="requiredstar">*</div> -->
                                                </div>
                                            </template>

                                        </div>
                                    </template>
                                    <template v-else-if="menuData.allow_in_attachment == 2">
                                        <div class="common-form-field">
                                            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                                <div class="form-label">Upload Document :</div>
                                            </div>
                                            <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                                <vue-dropzone
                                                    ref="dropzone" 
                                                    id="dropzone" 
                                                    :options="dropzoneOptions"
                                                    @vdropzone-success = "uploadAttachment"
                                                    @vdropzone-removed-file="removedSelectedFile"
                                                    :useCustomSlot=true
                                                    >
                                                    <div class="dropzone-custom-content">
                                                        <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                                        <div class="subtitle">(Select files from your computer.)</div>
                                                    </div>
                                                </vue-dropzone>
                                                <!-- <div class="requiredstar">*</div> -->
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="menuData.allow_in_attachment == 1">
                                        <div class="common-form-field">
                                            <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                                <div class="form-label">Link :</div>
                                            </div>
                                            <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                                <input v-validate="{url: {require_protocol: true }}" type="text" class="form-control" v-model="attachURL" id="attachURL" placeholder="Enter Link" name="abc">
                                                <span v-show="errors.has('attachURL')" class="help is-danger">{{ "The Link field is not a valid URL." }}</span>
                                                <!-- <div class="requiredstar">*</div> -->
                                            </div>
                                        </div>
                                    </template>


                                    <div class="clearfix"></div>
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label"><span>{{createdText}}</span> By: {{username}}</div>
                                    </div>

                                    <div class="mr-17 pb-2 float-l">
                                        <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="cancelAttachment()"><span>Cancel</span></button>
                                        <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addAttachment('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                        <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addAttachment('save')"><span id="createAttachment">Save</span></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    <!-- Forms -->
                </div>
                <!--page content-->
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import {HTTP} from '../http-common.js';
    import {commonMixins} from '../mixins/commonMixins';

    Vue.component("vueDropzone", vue2Dropzone);
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AttachmentAddForm',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                createdText: 'Created',
                edit_id: 0,
                attachTitle: "",
                attachURL: "",
                documentOrLink: {text: 'Document', value: 'doc'},
                documentOrLinkArr: [{
                        text: 'Document',
                        value: 'doc'
                    },
                    {
                        text: 'Link',
                        value: 'url'
                    }],
                form_slug: "",
                username: "",
                flag: true,
                dropzoneOptions: {
                    url: process.env.ROOT_API + "/store_document",
                    method: "POST",
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is to big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    maxFiles: 1,
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    //acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    }
                },
                /* isFileUploaded: false, */
                attachmentPaths: "",
                attachmentType: "",
                attachmentSize: "",
                loadAttchmentData: "",
            }

        },
        watch: {

            documentOrLink: function (documentOrLink) {
                var self = this;
                if (self.documentOrLink.value != 'doc') {
                    self.flag = false;
                } else {
                    self.flag = true;
                }
            }
        },

        created: function () {

        },
        mounted: function () {
            var self = this;
            this.$store.commit('changePastTab', 'attachments');
            //self.getRole();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.username = self.formatString(userJson["first_name"] + " " + userJson["last_name"]);
            }
            self.form_slug = this.$route.params.type;
            /* Get Role for conditionally provide add/edit feature */
            self.getMenuDetails(self.form_slug);

            /* setTimeout(function () {
             var path = window.location.pathname;
             var segments = path.split("/");
             if (segments[3]) {
             self.loadAttchment(segments[3]);
             $('#createAttachment').text('Edit');
             }
             }, 100); */

            this.$nextTick(function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3]) {
                    self.edit_id = segments[3];
                    self.loadAttchment(segments[3]);
                    $('#createAttachment').html('Update');
                    self.createdText = 'Updated';
                }
            })

        },
        methods: {

            cancelAttachment: function () {
                var self = this;
                self.$router.push("/" + self.form_slug);
            },

            removeAllFiles: function () {
                var self = this;
                self.$refs.dropzone.removeAllFiles();
            },

            removedSelectedFile: function (file, xhr, error) {

                var self = this;
                var removeFile = self.attachmentPaths;
                self.removeFileFromServer(removeFile);
            },

            removeFileFromServer: function (filePath) {

                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("tkn")},
                    data: {
                        filePath: filePath,
                    }
                };
                self.showLoader();
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                            self.attachmentPaths = "";
                            self.attachmentType = "";
                            self.attachmentSize = "";
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            //self.catchHandler(err, function () {});
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            uploadAttachment: function (file, response) {
                var self = this;
                //console.log(file);

                self.attachmentPaths = response.content;
                self.attachmentType = file.type;
                self.attachmentSize = file.size;
                //console.log(self.attachmentPaths);
                //this.$refs.dropzone.setOption('maxFiles',null);
            },

            addAttachment: function (type) {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                var config = {
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("tkn")
                    }
                };
                var URLType = "";
                if (self.menuData.allow_in_attachment == 3) {
                    URLType = self.documentOrLink.value;
                } else if (self.menuData.allow_in_attachment == 2) {
                    URLType = "doc";
                } else if (self.menuData.allow_in_attachment == 1) {
                    URLType = "url";
                }
                var fields = {
                    attachTitle: self.attachTitle,
                    attachURL: self.attachURL,
                    attachPath: self.attachmentPaths,
                    attachSize: self.attachmentSize,
                    attachType: self.attachmentType,
                    attachSlug: self.form_slug,
                    upload_type: URLType,
                    id: segments[3],
                };

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        self.showLoader();
                        HTTP.post('store_attachment', fields, config)
                                .then(function (response) {
                                    /*console.log("File removed successfully");*/
                                    if (response.data.status == "success") {
                                        if (self.menuData.allow_in_attachment >= 2) {
                                            if (self.attachmentPaths != '') {
                                                self.removeAllFiles();
                                            }
                                        }
                                        if (type == 'save') {
                                            self.$router.push("/" + self.form_slug);
                                        } else {
                                            self.attachTitle = '';
                                            self.attachURL = '';
                                            self.attachmentPaths = '';
                                            self.attachmentSize = '';
                                            self.attachmentType = '';
                                            self.documentOrLink = {text: 'Document', value: 'doc'};
                                        }
                                    } else {
                                        $("#alertError").show();
                                        /*console.log('else');*/
                                        if (response.data.content.length > 0) {
                                            var err = "";
                                            for (var i = 0; i < response.data.content.length; i++) {
                                                err += response.data.content[i] + "<br>";
                                            }
                                            $("#errorMsg").html(err);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                        }
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                    }
                });
            },

            loadAttchment: function (id) {

                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        'slug': self.form_slug,
                        'id': id,
                    }
                };
                self.showLoader();
                HTTP.get("get_document", config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                if (response.data.content != "") {

                                    self.attachTitle = response.data.content.title;

                                    if (response.data.content.upload_type != 'doc') {
                                        self.documentOrLink = {value: response.data.content.upload_type, text: 'Link'};
                                        self.attachURL = response.data.content.url;
                                    } else {
                                        self.documentOrLink = {value: response.data.content.upload_type, text: 'Document'};

                                        if (response.data.content.imageURL != '' || response.data.content.imageURL != null) {
                                            self.loadAttchmentData = response.data.content.imageURL;
                                            self.uploadManually();
                                        }
                                    }
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });

            },

            uploadManually: function (file) {

                var self = this;

                var url = self.loadAttchmentData[0]['url'];
                var file_name = self.getFileName(self.loadAttchmentData[0]['url']);
                var file_type = self.getFileType(self.loadAttchmentData[0]['type']);
                var file_size = self.loadAttchmentData[0]['size'];

                self.attachmentType = file_type;
                self.attachmentSize = Number(file_size);

                var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                self.$refs.dropzone.manuallyAddFile(file_data, url);
            },

            getFileName: function (file) {

                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]

                self.attachmentPaths = String(orgPath + "/" + file_name);

                return file_name;
            },

            getFileType: function (file_name) {

                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/AttachmentAddForm.vue